export const NAME = 'settings';

export const initialState = {
  sidebarIsCollapased: false,
  isBlocked: false,
};
